import { render, staticRenderFns } from "./date-field.vue?vue&type=template&id=4f18aeb2"
import script from "./date-field.vue?vue&type=script&lang=js"
export * from "./date-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports